import React from 'react';
import { SubmitError } from 'Components/Fields/SubmitError';
import { CancelButton, SubmitButton } from 'Components/Fields/Buttons';
import { password, required } from 'Utils/FormValidation';
import { FormField } from 'Components/HookFormFields/FormField';
import { useForm } from 'Hooks/useForm';
import 'Components/HookFormFields/PasswordField.css';
import './UpdatePassword.css';

const UpdatePasswordForm = ({ onFormSubmit, submitButtonText, onCancel }) => {
  const formName = 'updateAccountPasswordForm';
  const { formFieldProps, submitting, submitDisabled, formError, handleSubmit } = useForm({
    onFormSubmit,
    formName,
  });

  return (
    <form onSubmit={(event) => handleSubmit(event)}>
      <FormField
        name="oldPassword"
        label="Current Password"
        component="PasswordField"
        validate={[required]}
        autofocus
        {...formFieldProps}
      />
      <FormField
        name="newPassword"
        label="New Password"
        component="PasswordField"
        validate={[required, password]}
        warn
        {...formFieldProps}
      />
      <SubmitError error={formError} formName={formName} />
      <SubmitButton text={submitButtonText} submitting={submitting} mockDisabled={submitDisabled} />
      <CancelButton text="Cancel" onClick={onCancel} />
    </form>
  );
};

export default UpdatePasswordForm;
